import { alpha } from '@mui/material';
import { createTheme } from '@mui/material/styles';

import palette from './palette';
import typography from './typography';

const theme = createTheme({
  palette,
  typography,
  components: {
    MuiDataGrid: {
      styleOverrides: {
        root: {
          color: palette.primary.main,
        },
      }
    },
    MuiCardHeader: {
      styleOverrides: {
        title: {
          color: palette.primary.main,
          fontWeight: 600
        },
        subheader: {
          color: palette.primary.main,
        }
      }
    },
    MuiListItemText: {
      styleOverrides: {
        primary: {
          color: palette.primary.main,
          fontWeight: 600
        },
        secondary: {
          color: palette.primary.main,
        }
      },
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          color: palette.primary.main,
        },
      },
    },
    MuiTablePagination: {
      styleOverrides: {
        selectLabel: {
          color: palette.primary.main,
          marginBottom: 0,
        },
        displayedRows: {
          color: palette.primary.main,
          marginBottom: 0,
        },
      },
    },
    MuiTable: {
      defaultProps: {
        size: 'medium',
      },
    },
    MuiTableCell: {
      // NOTE: MUI v5.11.10 has a known bug where Table with size="small" internally
      // passes padding="default" to TableCell, but "default" is not a valid MUI v5 value.
      // This causes PropTypes warnings. The bug was fixed in MUI v5.14+.
      // Workaround: Set defaultProps to ensure proper styling, though PropTypes warnings may still appear.
      // Proper fix: Upgrade @mui/material to v5.14 or higher.
      defaultProps: {
        padding: 'normal',
      },
      styleOverrides: {
        root: {
          fontSize: 13,
        },
        paddingNone: {
          padding: 0,
        },
        paddingCheckbox: {
          padding: '0 0 0 4px',
        },
        sizeSmall: {
          padding: '6px 16px',
        },
      },
    },
    MuiDialogContentText: {
      styleOverrides: {
        root: {
          color: palette.primary.main,
        },
      },
    },
    MuiToggleButton: {
      styleOverrides: {
        root: {
          backgroundColor: palette.white,
          "&.Mui-selected": {
            backgroundColor: palette.primary.main,
            color: palette.white,
          }
        },
      },
    },
    MuiDatePicker: {
      styleOverrides: {
        toolbar: {
          backgroundColor: palette.primary.main,
        }
      },
    },
    MuiPickersToolbar: {
      styleOverrides: {
        root: {
          backgroundColor: palette.primary.main,
        }
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          // paddingLeft: 5,
          "&.Mui-focused": {
            borderColor: palette.primary.main,
          }
        },
        // sizeSmall: {
        //   height: 30
        // }
      }
    },
    MuiChip: {
      styleOverrides: {
        label: {
          fontWeight: 'normal!important'
        }
      }
    },
    MuiIconButton: {
      variants: [
        {
          props: { variant: "search" },
          style: {
            backgroundColor: palette.primary.contrastText,
            color: palette.primary.main,
            "&:hover": {
              color: palette.primary.contrastText,
              backgroundColor: palette.primary.light,
            },
          },
        },
        {
          props: { variant: "locate" },
          style: {
            backgroundColor: palette.secondary.main,
            color: palette.secondary.contrastText,
            "&:hover": {
              color: palette.primary.contrastText,
              backgroundColor: palette.primary.light,
            },
          },
        }
      ]
    },
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        text: {
          color: palette.primary.main,
        },
        contained: {
          backgroundColor: palette.primary.light,
        },
        containedPrimary: {
          backgroundColor: palette.primary.main,
        },
        containedSecondary: {
          backgroundColor: palette.secondary.main,
        },
      },
      variants: [
        {
          props: { variant: "activate" },
          style: {
            fontWeight: 600,
            justifyContent: "left",
            padding: "10px 20px",
            "&.active": {
              color: palette.secondary.main,
              backgroundColor: alpha(palette.primary.main, 0.05),
              fontWeight: 600,
            },
            "&:hover": {
              color: palette.secondary.main,
              backgroundColor: alpha(palette.primary.main, 0.08),
            },
          },
        },
        {
          props: { variant: "navigation" },
          style: {
            textTransform: "none",
            fontSize: "14px",
            color: palette.primary.main,
            outerWidth: "100%",
            innerWidth: "100%",
            display: "flex",
            justifyContent: "left",
            padding: "10px 20px",
            "&.active": {
              color: palette.secondary.main,
              backgroundColor: alpha(palette.primary.main, 0.05),
            },
          },
        },
        {
          props: { variant: "secondary" },
          style: {
            fontSize: "14px",
            color: palette.secondary.contrastText,
            backgroundColor: palette.secondary.main,
            height: 45,
            fontWeight: 600,
            "&:disabled": {
              color: palette.primary.contrastText,
              backgroundColor: alpha(palette.primary.main, 0.1),
            },
            "&:hover": {
              color: palette.secondary.contrastText,
              backgroundColor: palette.secondary.dark,
            },
          },
        },
        {
          props: { variant: "cancel" },
          style: {
            color: palette.primary.main,
            border: "1px solid #aaa199",
          },
        },
      ],
    },
  },
});

export default theme;
